import planningEditHelper from '../Helpers/planningEditHelper';

export default class PlanningDetailEditItem {
  // Object.assign in the constructor also copies every other column of the grid row
  // (the save endpoint PUTs the full item back); only the fields the wizard reads or
  // writes through a typed instance are declared here.
  PlanningDetailId: number;
  PricingId: number;
  ClientId: number;
  NumberOfContractedAssignments: number;
  MysteryShoppingPlatformPricingId: number | null;
  IsDateLocked: boolean;
  TpRunId: number | string | null;
  WaveId: number | string | null;
  StartDate: Date;
  EndDate: Date;
  ExtendedEndDate: Date | null;
  NumberOfPlannedAssignments: number;
  ExtendEndDate: boolean;
  ApplyTargetRates: boolean;
  TargetAssignmentRate: number[];
  TargetCompletionRate: number[];

  constructor(selectedItem) {
    Object.assign(this, selectedItem);
    this.StartDate = planningEditHelper.toNoonDate(selectedItem.StartDate);
    this.EndDate = planningEditHelper.toNoonDate(selectedItem.EndDate);
    if (this.NumberOfPlannedAssignments === 0) {
      this.NumberOfPlannedAssignments = selectedItem.NumberOfContractedAssignments;
    }
    this.ExtendEndDate = !!selectedItem.ExtendedEndDate;
    this.ExtendedEndDate = this.ExtendEndDate ? planningEditHelper.toNoonDate(selectedItem.ExtendedEndDate) : null;
    this.ApplyTargetRates = false;
    this.TargetAssignmentRate = planningEditHelper.toRateArray(
      selectedItem.TargetAssignmentRate1,
      selectedItem.TargetAssignmentRate2,
      selectedItem.TargetAssignmentRate3,
      selectedItem.TargetAssignmentRate4,
      [30, 45, 25, 0]
    );
    this.TargetCompletionRate = planningEditHelper.toRateArray(
      selectedItem.TargetCompletionRate1,
      selectedItem.TargetCompletionRate2,
      selectedItem.TargetCompletionRate3,
      selectedItem.TargetCompletionRate4,
      [20, 30, 30, 20]
    );
  }
}
